import gql from 'graphql-tag'

/**
 * Query
 */
const GET_INTERNAL_ASSISTANCE_REPORT_BY_FILTER = gql`
  query getReportInternalAssistance($input: FilterReportInternalAssistance!) {
    getReportInternalAssistance(input: $input) {
      dates {
        date
        day_name
        date_formatted
      }
      items {
        employee {
          id
          uid
          email
          name
          last_name
          mothers_last_name
          fullName
          fullLastName
          document_type
          document_number
          phone_number
        }
        assistances {
          date
          value
          permiso
        }
      }
    }
  }
`

export {
  GET_INTERNAL_ASSISTANCE_REPORT_BY_FILTER
}
